import { TextButton } from '@/components/ui/text-button';

// Accounts made with Google or Apple have no password to check, so they set one by email first
export function PasswordLinkPrompt({ sent, onSend }: { sent: boolean; onSend: () => void }) {
  return (
    <p className="text-lureo-13 text-lureo-ink-subtle leading-5">
      Signed up with Google or Apple, or forgot your password?{' '}
      <TextButton tone="link" size="sm" disabled={sent} onClick={onSend}>
        {sent ? 'Link sent' : 'Email me a link to set one'}
      </TextButton>
    </p>
  );
}
